import React from "react";
import { Outlet } from "react-router-dom";

const User = () => {
  return (
    <div className="user-container">
      <Outlet /> {/* ✅ Renders the child routes (profile, backup codes, etc.) */}
    </div>
  );
};

export default User;